'use es6';

import PropTypes from 'prop-types';
import styled from 'styled-components';
import UICardWrapper from 'UIComponents/card/UICardWrapper';
import { SLINKY, MARIGOLD, OZ, CALYPSO, GREAT_WHITE, KOALA } from 'HubStyleTokens/colors';
import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import FormattedCurrency from 'I18n/components/FormattedCurrency';
import Small from 'UIComponents/elements/Small';
import H7 from 'UIComponents/elements/headings/H7';
import H3 from 'UIComponents/elements/headings/H3';
import arrowCircleUrl from 'bender-url!../../../images/left-arrow-circle.svg';
import checkmarkCircleUrl from 'bender-url!../../../images/checkmark-circle.svg';
import UIImage from 'UIComponents/image/UIImage';
import UIFlex from 'UIComponents/layout/UIFlex';
import { SkeletonBlock } from '../../components/Skeleton';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const colorByLevel = {
  free: SLINKY,
  starter: MARIGOLD,
  pro: OZ,
  enterprise: CALYPSO
};
const CardWrapper = styled(UICardWrapper).withConfig({
  displayName: "PricingCard__CardWrapper",
  componentId: "sc-1ksnc41-0"
})(["border-top:5px solid ", ";max-width:250px;width:100vw;height:485px;text-align:left;margin-bottom:0 !important;.info{height:130px;border-bottom:1px solid ", ";line-height:12px;text-align:center;}.features{text-align:center;}"], props => colorByLevel[props.level], GREAT_WHITE);
const BorderUIFlex = styled(UIFlex).withConfig({
  displayName: "PricingCard__BorderUIFlex",
  componentId: "sc-1ksnc41-1"
})(["margin-bottom:16px;box-sizing:content-box;margin-top:36px;", ""], props => props.isCurrentPlan && `
    background-color: ${KOALA};
    padding: 8px;
    margin-top: 0;
    margin-bottom: 8px;
    margin-left: -8px;
    margin-right: -8px;
    border: 1px solid ${GREAT_WHITE};
    border-radius: 5px;
  `);
const FeaturesList = styled.ul.withConfig({
  displayName: "PricingCard__FeaturesList",
  componentId: "sc-1ksnc41-2"
})(["list-style-type:none;text-align:left;line-height:36px;padding-right:20px;padding-left:20px;"]);
const PricingCard = ({
  level,
  features,
  currency,
  price,
  isCurrentPlan,
  priceLoading
}) => {
  return /*#__PURE__*/_jsx("div", {
    children: /*#__PURE__*/_jsxs(BorderUIFlex, {
      align: "center",
      direction: "column",
      isCurrentPlan: isCurrentPlan ? 1 : 0,
      children: [isCurrentPlan && /*#__PURE__*/_jsx(Small, {
        className: "m-bottom-2",
        weight: "bold",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "learningCenter.softwareDesirability.modal.pricingSection.currentPlan"
        })
      }), /*#__PURE__*/_jsxs(CardWrapper, {
        level: level,
        children: [/*#__PURE__*/_jsxs("div", {
          className: "info",
          children: [/*#__PURE__*/_jsx(H3, {
            className: "m-top-7 m-bottom-3",
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: `learningCenter.softwareDesirability.modal.pricingSection.${level}`
            })
          }), priceLoading ? /*#__PURE__*/_jsx(SkeletonBlock, {
            style: {
              margin: 'auto',
              width: '150px',
              height: '14px'
            }
          }) : /*#__PURE__*/_jsx(Small, {
            use: "help",
            children: /*#__PURE__*/_jsx(FormattedReactMessage, {
              message: level === 'free' ? `learningCenter.softwareDesirability.modal.pricingSection.pricingFree` : `learningCenter.softwareDesirability.modal.pricingSection.pricingPaid`,
              options: {
                price: /*#__PURE__*/_jsx(FormattedCurrency, {
                  abbreviate: true,
                  abbreviateThreshold: 100000,
                  currencyCode: currency,
                  maxFractionDigits: 3,
                  simplifyCurrency: true,
                  stripInsignificantZeros: false,
                  value: price
                })
              }
            })
          }), /*#__PURE__*/_jsx("br", {}), level === 'free' && /*#__PURE__*/_jsx(Small, {
            use: "help",
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "learningCenter.softwareDesirability.modal.pricingSection.noCreditCard"
            })
          })]
        }), /*#__PURE__*/_jsxs("div", {
          className: "features",
          children: [/*#__PURE__*/_jsx(H7, {
            className: "m-y-4",
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "learningCenter.softwareDesirability.modal.pricingSection.popularFeatures"
            })
          }), /*#__PURE__*/_jsx(FeaturesList, {
            children: features.map((feature, i) => /*#__PURE__*/_jsxs("li", {
              children: [/*#__PURE__*/_jsx(UIImage, {
                src: level !== 'free' && i === 0 ? arrowCircleUrl : checkmarkCircleUrl,
                style: {
                  display: 'inline',
                  marginBottom: '2px',
                  marginRight: '8px',
                  backgroundColor: level !== 'free' && i === 0 && colorByLevel[level],
                  borderRadius: '50%'
                }
              }), feature]
            }, i))
          })]
        })]
      })]
    })
  });
};
PricingCard.propTypes = {
  currency: PropTypes.string.isRequired,
  features: PropTypes.array.isRequired,
  isCurrentPlan: PropTypes.bool,
  level: PropTypes.oneOf(['free', 'starter', 'pro', 'enterprise']).isRequired,
  price: PropTypes.number.isRequired,
  priceLoading: PropTypes.bool
};
export default PricingCard;